export function getHeroPhoto(content) {
  return content.child('hero-content').links()[0];
}
